import {Color} from "three";

export const MATERIAL_PROPS_DB = [
    {
        materialName:'WallsMat',
        emmissiveIntensity:1, //Emissive intensity
        emmisiveColor:new Color(0xFFFFFF),
        aOIntensity:1.2, //Ambient occlusion
    },

    {
        materialName:'CeilingMat',
        emmissiveIntensity:1, //Emissive intensity
        emmisiveColor:new Color(0xFFFFFF),
        aOIntensity:1.2, //Ambient occlusion
    },

    {
        materialName:'CeilingMetalBars',
       // emmissiveIntensity:1, //Emissive intensity
       // emmisiveColor:new Color(0x000000),
        aOIntensity:.5, //Ambient occlusion
    },

]
